import React from 'react';
import '../styles/SpaceSwitcher.css';

export const getSpaceOptionId = (space) =>
  String(space?.id ?? space?.space_id ?? space?.spaceId ?? '');

const SpaceSwitcher = ({
  spaces = [],
  value,
  onChange,
  className = '',
  showSingle = false,
  leadingOption = null
}) => {
  const activeSpaces = spaces.filter((s) => s && getSpaceOptionId(s));

  if (activeSpaces.length === 0) {
    return null;
  }
  if (activeSpaces.length <= 1 && !showSingle && !leadingOption) {
    return null;
  }

  return (
    <div className={`space-switcher ${className}`.trim()} role="group" aria-label="Active space">
      <span className="space-switcher-label">Space</span>
      <div className="space-switcher-options">
        {leadingOption ? (
          <button
            type="button"
            className={`space-switcher-option${
              leadingOption.value === value ? ' space-switcher-option--active' : ''
            }`}
            aria-pressed={leadingOption.value === value}
            onClick={() => onChange(leadingOption.value)}
          >
            {leadingOption.label}
          </button>
        ) : null}
        {activeSpaces.map((space) => {
          const id = getSpaceOptionId(space);
          const selected = String(value) === id;
          return (
            <button
              key={id}
              type="button"
              className={`space-switcher-option${selected ? ' space-switcher-option--active' : ''}`}
              aria-pressed={selected}
              onClick={() => onChange(id)}
            >
              {space.name || 'Room'}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default SpaceSwitcher;
